module.exports = __webpack_public_path__ + "static/media/furni3.8e6f9c44.jpg";